<template>
	<div>
		<table class="table">
			<tr v-if="counterpartRole">
				<td>{{ counterpartRole }}</td>
				<td>{{ counterpart.company_name }}</td>
			</tr>
			<tr>
				<td>{{ __("Article") }}</td>
				<td>{{ tableParameters.articleDescription }}</td>
			</tr>

			<tr>
				<td>{{ __("Quality") }}</td>
				<td>{{ tableParameters.qualityString }}</td>
			</tr>

			<tr>
				<td>{{ __("Quantity") }}</td>
				<td>{{ tradable.qty__mt }} t</td>
			</tr>

			<tr>
				<td>{{ __("Price") }}</td>
				<td v-if="tradable.price__mt">{{ tradable.price__mt }} €/t</td>
				<td v-else>
					<i>{{ __("n.a.") }}</i>
				</td>
			</tr>

			<tr>
				<td>{{ __("Fulfilment Date") }}</td>
				<td>{{ tableParameters.dateString }}</td>
			</tr>

			<tr>
				<td>{{ __("Location") }}</td>
				<td>{{ tableParameters.locationString }}</td>
			</tr>
			<tr v-if="tableParameters.until">
				<td>
					<b>{{ __("Validity") }}</b>
				</td>
				<td>
					<b>{{ __("Until") }} {{ tableParameters.until }}</b>
				</td>
			</tr>
		</table>
	</div>
</template>

<script>
export default {
	props: {
		tradable: {
			type: Object,
			required: true,
		},
		counterpart: {
			type: Object,
			required: true,
		},
		counterpartRole: {
			type: String,
			required: true,
		},
		tableParameters: {
			type: Object,
			required: true,
		},
	},
};
</script>
